import React, { Component } from 'react';
import { Switch, Route, HashRouter } from 'react-router-dom';
import "./invoice.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu';
import config from 'config';
import LibraryApiCall from 'LibraryApiCall';
import ReactHtmlParser from 'react-html-parser';
import SuccessModal from 'LIBRARY/CommonResources/SuccessModal/SuccessModal';
import DeleteModal from 'LIBRARY/CommonResources/DeleteModal/DeleteModal';
import Spinner from 'LIBRARY/CommonResources/SpinnerLoader/Spinner';
import Pagination from 'react-js-pagination';
import { getLibraryAccessDetails, setAssignedInstitute } from 'LIBRARY/Actions/AdminDetailsAction.js';
import moment from 'moment';
import $ from 'jquery';
import { CSVLink } from 'react-csv';
import { connect } from 'react-redux';
import AddBill from 'LIBRARY/Components/Invoices/AddBill/AddBill.js';
import ButtonLoader from 'LIBRARY/CommonResources/ButtonLoader/ButtonLoader';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import ImportInvoice from './importInvoice';

let apiPath = '/api/accounting/accounting.php';

class Invoice extends Component {


    constructor(props) {
        super(props);
        this.state = {
            isExpenseFetching: false,
            expenseList: [],
            addExpenseModal: false,
            addBillModal: false,
            offset: 0,
            limit: 10,
            activePage: 1,
            totalCount: 0,

            // VARIABLES FOR SUCCESS MODAL
            successModal: false,
            successModalType: '',
            successMessage: '',

            // VARIABLES TO EXPORT EXPENSE
            exportDetails: false,

            // VARIABLES FOR ADD / EDIT EXPENSE
            uniqueId: '',
            vendorId: '',
            vendorName: '',
            accountId: '',
            paymentDate: '',
            paymentMethod: '',
            linkTo: '',
            referenceNumber: '',
            categoryId: '',
            description: '',
            billDate: '',
            billNumber: '',
            amount: '',
            taxType: 'inclusive',
            taxValue: '',
            note: '',
            poAmount: 0,
            poName: '',
            attachments: [],
            attachmentCount: 0,
            isEditMode: false,
            totalAmount: 0,
            total_amount: '',
            attachmentJson: [],
            attachmentArray: [],
            assetCategoryDetails: {
                0: {
                    'categoryId': '',
                    'index': 0,
                    'description': '',
                    'amount': '',
                    'taxValue': ''
                }
            },

            // VARIABLES FOR ADD / DELETE BILL
            poId: '',
            dueDate: '',

            // VARIABLES FOR DELETE EXPENSES
            deleteExpenseModal: false,
            deleteKey: '',
            confirmText: '',
            deleteWarning: '',
            selectedExpenseIds: [],
            selectedExpenseIdsSet: new Set(),
            allSelected: false,
            expenseId: [],

            //EXPORT CSV VARIABLES
            exportCSVHeaders: [
                { label: "Sr. No.", key: "srNo" },
                { label: "Payee Name", key: "payeeName" },
                // { label: "Payment Date", key: "paymentDate" },
                // { label: "Type", key: "billType" },
                { label: "Amount", key: "amount" },
                // { label: "Linked To", key: "linkTo" },
                { label: "Bill Number", key: "billNumber" },
                { label: "Bill Date", key: "billDate" },
                // { label: "Due Date", key: "dueDate" },
                { label: "Attachments", key: "attachmentCount" },
            ],
            exportCSVData: [],

            // VARIABLES TO VIEW EXPENSE
            billData: [],
            viewExpenseModal: false,

            //VARIABLE VIEW ATTACHMENt
            showAttachmentodal: false,
            attachmentData: [],
            selectedImag: '',
            selectedAttIndex: 0,
        }
    }

    componentDidMount() {
        // METHOD TO GET ALL EXPENSES
        this.getExpenses();
    }

    // API CALL TO GET ALL EXPENSES
    getExpenses = async () => {
        this.setState({
            isExpenseFetching: true,
            expenseList: []
        });

        let requestData = {
            "instituteId": config.institute_id,
            "limit": this.state.limit,
            "offset": this.state.offset,
            "getPODetails": "false",
            "linkedModule":"library"
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'accounting_getAllExpenses',
            requestData,
            apiPath
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getExpenses()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                this.setState({
                    isExpenseFetching: false
                });
                let apiResult = jsonResponse.APIResult.data;
                Object.values(apiResult).map((expense, index) => {
                    expense['srNo'] = index + 1;
                });

                this.setState({
                    expenseList: apiResult,
                    totalCount: jsonResponse.APIResult.Total
                });
            }
            else {
                this.setState({
                    isExpenseFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong. Please try again later.'
                });
            }
        }
    }

    // METHOD TO CLOSE ADD BILL MODAL
    closeAddBillModal = () => {
        this.setState({
            addBillModal: false,
            vendorId: '',
            poId: '',
            dueDate: '',
            accountId: '',
            linkTo: '',
            totalAmount: 0,
            total_amount: 0,
            taxType: 'inclusive',
            note: '',
            billDate: '',
            billNumber: '',
            vendorName: '',
            poName: '',
            poAmount: 0,
            attachments: [],
            attachmentCount: 0,
            isEditMode: false,
            assetCategoryDetails: {
                0: {
                    'index': 0,
                    'categoryId': '',
                    'description': '',
                    'amount': '',
                    'taxValue': ''
                }
            }
        });
    }

    // METHOD TO EDIT EXPENSE / BILL
    editExpense = (expense) => {

        const editGrantAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['invoice'].find(access => access === 'edit');

        if (editGrantAccess !== undefined) {
            this.setState({
                isEditMode: true
            });
        } 
        else 
        {
            this.setState({
                successModal: true,
                successModalType: 'warning',
                successMessage: 'This operation is restricted by the Library admin.'
            });
        }

        if (expense.expenseType == 'Expense') {
            Object.values(expense.categoryDetails).map((category, index) => {
                if (category.hasOwnProperty('category')) {
                    category['categoryId'] = '';
                    delete category['category'];
                }
                if (category.hasOwnProperty('ammount')) {
                    category['amount'] = category['ammount'];
                    delete category['ammount'];
                }
                if (category.hasOwnProperty('tax')) {
                    category['taxValue'] = '';
                    delete category['tax'];
                }
                if (category.hasOwnProperty('taxDetails')) {
                    category['taxValue'] = '';
                    delete category['taxDetails'];
                }

                category['index'] = index;
            });
            this.setState({
                addExpenseModal: true,
                addBillModal: true,
                uniqueId: expense.Uniqueid,
                vendorId: expense.vendorId,
                accountId: expense.bankAccountId == null ? '' : expense.bankAccountId,
                paymentDate: expense.paymentDate == null ? '' : expense.paymentDate,
                paymentMethod: expense.paymentMethod == null ? '' : expense.paymentMethod,
                linkTo: expense.linkTo == null ? '' : expense.linkTo,
                referenceNumber: expense.reference_number == null ? '' : expense.reference_number,
                taxType: expense.taxType == null ? 'inclusive' : expense.taxType,
                billDate: expense.billDate == null ? '' : expense.billDate,
                billNumber: expense.billNumber == null ? '' : expense.billNumber,
                note: expense.note == null ? '' : expense.note,
                attachments: expense.attachment == null ? [] : expense.attachment,
                // attachmentJson: expense.attachmentJson == null ? [] : expense.attachmentJson,
                attachmentArray: expense.attachmentArray == null ? [] : expense.attachmentArray,
                attachmentCount: expense.attachmentArray == null ? 0 : expense.attachmentArray.length,
                // totalAmount: expense.totalAmount == null ? 0 : expense.totalAmount,
                total_amount: expense.totalAmount == null ? 0 : expense.totalAmount,
                assetCategoryDetails: expense.categoryDetails == null ? this.state.assetCategoryDetails : expense.categoryDetails
            });
        } else if (expense.expenseType == 'Bill') {
            Object.values(expense.categoryDetails).map((category, index) => {
                if (category.hasOwnProperty('category')) {
                    category['categoryId'] = '';
                    delete category['category'];
                }
                if (category.hasOwnProperty('ammount')) {
                    category['amount'] = category['ammount'];
                    delete category['ammount'];
                }
                if (category.hasOwnProperty('tax')) {
                    category['taxValue'] = '';
                    delete category['tax'];
                }
                if (category.hasOwnProperty('taxDetails')) {
                    category['taxValue'] = '';
                    delete category['taxDetails'];
                }

                category['index'] = index;
            });
            this.setState({
                poId: expense.poId == null ? '' : expense.poId,
                poAmount: expense.poData.length == 0 || expense.poData == null ? 0 : expense.poData.prDetails.poAmount,
                poName: expense.poData.length == 0 || expense.poData == null ? '' : expense.poData.seriesTitle + expense.poData.seriesCounter,
                addBillModal: true,
                uniqueId: expense.Uniqueid,
                vendorId: expense.vendorId,
                dueDate: expense.dueDate == null ? '' : expense.dueDate,
                vendorName: expense.vendorName == null ? '' : expense.vendorName,
                linkTo: expense.linkTo == null ? '' : expense.linkTo,
                taxType: expense.taxType == null ? 'inclusive' : expense.taxType,
                billDate: expense.billDate == null ? '' : expense.billDate,
                billNumber: expense.billNumber == null ? '' : expense.billNumber,
                note: expense.note == null ? '' : expense.note,
                attachments: expense.attachments == null ? [] : expense.attachments,
                // attachmentJson: expense.attachmentJson == null ? [] : expense.attachmentJson,
                attachmentArray: expense.attachmentArray == null ? [] : expense.attachmentArray,
                attachmentCount: expense.attachmentArray == null ? 0 : expense.attachmentArray.length,
                // totalAmount: expense.totalAmount == null ? 0 : expense.totalAmount,
                total_amount: expense.totalAmount == null ? 0 : expense.totalAmount,
                assetCategoryDetails: expense.categoryDetails == null ? this.state.assetCategoryDetails : expense.categoryDetails
            });
        }
    }

    // METHOD TO UPDATE VENDOR PAGINATION COUNT
    updatePaginationCount = (pageNumber) => {
        this.setState({
            offset: (pageNumber - 1) * this.state.limit,
            activePage: pageNumber,
            allSelected: false,
            selectedExpenseIds: [],
            selectedExpenseIdsSet: new Set()
        },
            function () {
                //CALLING API TO GET LIST WITH UPDATED STATUS
                this.getExpenses()
            }
        )
    }

    // METHOD TO GET MESSAGE AND STATUS ON ADD / UPDATE EXPENSE AND BILL
    getMessage = (status, message) => {
        this.setState({
            successModal: true,
            successModalType: status,
            successMessage: message
        }, () => {
            this.getExpenses();
        });
    }

    // METHOD TO SELECT SINGLE EXPENSE / BILL
    selectSingleExpense = (expense) => {
        let selectedExpenseIds = this.state.selectedExpenseIds;

        if (selectedExpenseIds.includes(expense)) {
            selectedExpenseIds = selectedExpenseIds.filter(id => id != expense);
        } else {
            selectedExpenseIds.push(expense);
        }

        this.setState({
            selectedExpenseIds
        });
    }

    // METHOD TO SELECT MULTIPLE EXPENSES / BILLS
    selectAllExpenses = (e) => {
        let selectedExpenseIdsSet = this.state.selectedExpenseIdsSet;

        if (e.target.checked) {
            Object.values(this.state.expenseList).map(expense => {
                selectedExpenseIdsSet.add(expense.Uniqueid);
            });
            this.setState({
                allSelected: true
            });
        } else {
            Object.values(this.state.expenseList).map(expense => {
                selectedExpenseIdsSet.delete(expense.Uniqueid);
            });
            this.setState({
                allSelected: false
            });
        }

        this.setState({
            selectedExpenseIds: Array.from(selectedExpenseIdsSet)
        });
    }

    // METHOD TO CLOSE SUCCESS MODAL
    closeSuccessModal = () => {
        this.setState({
            successModal: false
        });
    }

    // METHOD TO DELETE SINGLE EXPENSE MODAL
    deleteSingleExpense = (expense) => {
        let expenseId = this.state.expenseId;
        expenseId.push(expense.Uniqueid);
        this.setState({
            deleteExpenseModal: true,
            deleteKey: 'singleExpense',
            expenseId
        });
    }

    // METHOD TO CHECK ACCESS FOR ADD BILL
    addBillAccess = () => {

        const addGrantAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['invoice'].find(access => access === 'add');

        if (addGrantAccess !== undefined) {
            this.setState({ 
                addBillModal: true 
            })
        } else {
            this.setState({
                successModal: true,
                successModalType: 'warning',
                successMessage: 'This operation is restricted by the Library admin.'
            });
        }
    }

    // METHOD TO RETURN DELETE EXPENSE MODAL
    returnDeleteExpenseModal = () => {
        return (
            <div className={this.state.deleteExpenseModal ? "modal fade show" : "modal fade"} id="modalContainer" >
                <div className="modalDataContainer" >
                    <div className="modal-content deleteModalContent">

                        <div className="modal-header modalHeader deleteModalHeader">
                            <h2><FontAwesomeIcon icon={['fas', 'exclamation-triangle']} size="am" color="#FFFFFF" style={{ marginRight: 20 }} /><span style={{ color: "#FFFFFF" }}>Are you sure?</span></h2>
                            <FontAwesomeIcon icon={['fas', 'times']} size="lg" color="#FFFFFF" onClick={() => this.closeDeleteModal()} style={{ cursor: "pointer" }} />
                        </div>

                        <div className="modal-body" style={{ paddingLeft: '4%' }}>

                            <p style={{ fontSize: 16, fontWeight: "bold" }}>NOTE:</p>

                            <ul>
                                <li>Once deleted cannot be retrieved.</li>
                                <li>All data associated with this entry will be deleted permanently.</li>
                            </ul>

                            <p className="deleteConfirmationText">If you want to delete the entry , type <b>DELETE PERMANENTLY</b> in block/capital letters in below input text for confirmation.</p>

                            <input type="text" style={{ width: '40%' }} value={this.state.confirmText} onChange={(e) => e.target.value == 'DELETE PERMANENTLY' ? this.setState({ confirmText: e.target.value, deleteWarning: '' }) : this.setState({ confirmText: e.target.value, deleteWarning: 'Please type "DELETE PERMANENTLY" to delete the expense / bill.' })} placeholder="Please type DELETE PERMANENTLY" maxLength={18} onPaste={(e) => e.preventDefault()} onDrop={(e) => e.preventDefault()} />

                            <span style={{ display: this.state.deleteWarning.length > 0 ? 'block' : 'none', color: 'red', marginTop: 10 }}>{this.state.deleteWarning}</span>

                        </div>

                        <div className="modal-footer">

                            <div id="addAssetButtonContainer">
                                <button className="btn btn-outline-primary waves-effect" onClick={() => this.state.confirmText == 'DELETE PERMANENTLY' ? this.deleteExpense() : this.setState({ deleteWarning: 'Please type "DELETE PERMANENTLY" to delete the expense.' })}>Yes</button>

                                <button className="btn btn-primary" onClick={() => this.closeDeleteModal()}>No</button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }

    // METHOD TO DELETE THE EXPENSE
    deleteExpense = async () => {
        let requestData = {
            "uids": this.state.deleteKey == 'singleExpense' ? Array.from(this.state.expenseId) : this.state.selectedExpenseIds,
            "iid": config.institute_id,
            "facultyId": config.faculty_id
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'accounting_deleteExpense',
            requestData,
            apiPath
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.deleteExpense()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                this.setState({
                    deleteExpenseModal: false,
                    expenseId: [],
                    selectedExpenseIds: [],
                    selectedExpenseIdsSet: new Set(),
                    offset: 0,
                    activePage: 1,
                    confirmText:''
                });
                this.getExpenses();
                if (apiResult.deletedExpenseCount > 0) {

                    let message = "";

                    if (apiResult.libraryLinkedBill > 0)
                    {
                        message += " library resource ";
                    }

                    if (apiResult.assetLinkedBill > 0)
                    {
                        if(message != "")
                        {
                            message += " and ";
                        }
                        message += " inventory asset";
                    }

                    let finalMsg = "";
                    if(message != "")
                    {
                        finalMsg = " The remaining expense(s)/bill(s) are linked with"+message;
                    }

                    this.setState({
                        successModal: true,
                        successModalType: 'success',
                        successMessage: apiResult.deletedExpenseCount + ' ' + 'expense(s) / bill(s) deleted successfully.'+finalMsg,
                        confirmText: '',
                        selectedExpenseIds: []
                    });
                } 
                else 
                {
                    let message = "";

                    if (apiResult.libraryLinkedBill > 0)
                    {
                        message += " library resource ";
                    }

                    if (apiResult.assetLinkedBill > 0)
                    {
                        if(message != "")
                        {
                            message += " and ";
                        }
                        message += " inventory asset";
                    }

                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: 'The selected expense(s)/bill(s) are linked with '+message
                    });
                }
            }
            else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while deleting expense(s) / bill(s). Please try again later.'
                });
            }
        }
    }

    // METHOD TO CLOSE DELETE MODAL
    closeDeleteModal = () => {
        this.setState({
            deleteExpenseModal: false,
            confirmText: '',
            deleteWarning: ''
        });
    }

    //FUNCTION DEFINED TO GET THE SELECTED ENTRIES FROM THE TABLE AND THEN EXPORTING THEM TO CSV FILE
    checkSelectedTableRowsForExport = () => {

        let expenseList = this.state.expenseList;
        let selectedExpenseIds = this.state.selectedExpenseIds;
        let exportCSVData = this.state.exportCSVData;
        exportCSVData = [];

        if (selectedExpenseIds.length == 0) {
            this.setState({
                successModal: true,
                successModalType: 'warning',
                successMessage: 'Please select expenses that you want to export.'
            });
        } else {
            selectedExpenseIds.map(expenseId => {
                Object.values(expenseList).map((expense, index) => {
                    if (expense.Uniqueid == expenseId) {
                        exportCSVData.push({
                            srNo: expense.srNo,
                            payeeName: expense.vendorName == null ? '' : expense.vendorName,
                            paymentDate: expense.paymentDate == null ? '' : expense.paymentDate,
                            billType: expense.expenseType,
                            amount: expense.totalAmount == null ? 0 : expense.totalAmount,
                            linkTo: expense.linkTo == null ? '' : expense.linkTo,
                            billNumber: expense.billNumber == null ? '' : expense.billNumber,
                            billDate: expense.billDate == null ? '' : expense.billDate,
                            dueDate: expense.dueDate == null ? '' : expense.dueDate,
                            attachmentCount: expense.attachment == null ? 0 : expense.attachment.length
                        });
                    }
                });
            })

            this.setState({
                exportCSVData
            }, () => this.exportCSVOfExpenseList());
        }
    }

    //FUNCTION DEFINED TO INITIATE THE EXPORT DOWNLOAD PROCESS FOR EXPENSE LIST
    exportCSVOfExpenseList = () => {

        setTimeout(() => {

            $('.exportCSVExpenseData')[0].click()
        }, 2000);

    }

    // METHOD TO OPEN VIEW EXPENSE DETAILS MODAL WITH EXPENSE DATA
    viewExpenseDetails = (expense) => {
        this.setState({
            viewExpenseModal: true,
            billData: expense
        });
    }

    // METHOD TO RETURN VIEW EXPENSE DETAILS MODAL
    returnViewExpenseModal = () => {

        return (
            <div id="viewExpenseSideMenu" style={{ display: this.state.viewExpenseModal ? 'flex' : 'none' }}>
                <div id="viewExpenseDataContainer">

                    <div id="viewExpenseHeader" className="row">
                        <FontAwesomeIcon icon={['fas', 'times']} size="lg" color="#000" onClick={() => this.closeViewExpense()} style={{ cursor: "pointer" }} />
                        <h3 className="col-11">View</h3>
                    </div>

                    <div id="viewExpenseBody">
                        <div className="col-md-12 bill-number">
                            <h3 style={{ paddingLeft: '2%' }}>Bill Number - {this.state.billData.billNumber}</h3>
                        </div>

                        <div className="col-md-12">
                            <div className="row">
                                <h5 className="col-md-5">Payee</h5>
                                <div style={{ fontSize: "16px" }} className="col-md-7">{this.state.billData.vendorName == "" ? "-" : this.state.billData.vendorName}</div>
                            </div>
                            <div className="row pt-5 pb-5">
                                <h5 className="col-md-5">Bill Date</h5>
                                <div style={{ fontSize: "16px" }} className="col-md-7">{this.state.billData.billDate == "0000-00-00" ? "-" : this.state.billData.billDate}</div>
                            </div>
                            <div className="row">
                                <h5 className="col-md-5">Attachments</h5>
                                <div style={{ fontSize: "16px" }} className="col-md-7">
                                    {this.state.attachmentArray == null ? 0 : this.state.billData.attachmentArray != undefined && this.state.billData.attachmentArray.length}
                                </div>
                            </div>
                            <div className="row pt-5">
                                <h5 className="col-md-5">Amount</h5>
                                <div style={{ fontSize: "16px" }} className="col-md-7">
                                    <FontAwesomeIcon icon={['fas', 'rupee-sign']} size="sm" style={{ marginRight: 7 }} />{this.state.billData.totalAmount} /-
                                </div>
                            </div>
                            <div className="row pt-5">
                                <h5 className="col-md-5">Note</h5>
                                <div style={{ fontSize: "16px" }} className="col-md-7">
                                    {this.state.billData.note == "" ? '-' : this.state.billData.note}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="pt-5 pr-3" id="viewExpenseFooter" style={{ marginBottom: 10 }}>
                        <button className="btn btn-outline-primary waves-effect" onClick={() => this.closeViewExpense()}>Close</button>
                    </div>
                    <br />
                    <br />
                    <br />
                </div>
            </div >
        );
    }

    // METHOD TO CLOSE VIEW EXPENSE MODAL
    closeViewExpense = () => {
        this.setState({
            viewExpenseModal: false
        });
    }

    // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> VIEW ATTACHMENT MODAL >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
    showAttachmentodalModal = () => {
        return (
            <div className={this.state.showAttachmentodal ? "modal fade show in" : "modal fade"} id="modalContainer" role="dialog">
                <div className="modal-dialog modal-lg modal-dialog-centered filterCommittee-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header modalHeader attachModalHeader" style={{ backgroundColor: '#0465AC' }}>
                            <h6 className="modal-title text-white" >Attachment</h6>
                            <FontAwesomeIcon icon={['fas', 'times']} size="sm" className="text-white" onClick={() => this.setState({ showAttachmentodal: false, attachmentData: [], selectedImag: '', selectedAttIndex: 0, })} style={{ cursor: "pointer" }} />
                        </div>
                        <div className="modal-body" style={{ maxHeight: '540px' }}>
                            <div className="row">
                                <div className="col-md-2">
                                    {this.state.attachmentData && Object.values(this.state.attachmentData).map((att, i) => {
                                        if (this.state.selectedImag == '') {
                                            this.setState({
                                                selectedImag: Object.values(this.state.attachmentData)[0].filepath
                                            })
                                        }
                                        return (
                                            <button
                                                style={{ whiteSpace: 'nowrap', backgroundColor: this.state.selectedAttIndex == i ? '#0465ac' : '' }}
                                                className={this.state.selectedAttIndex == i ? 'btn text-white' : 'btn text-black'}
                                                onClick={(e) => this.setState({ selectedImag: att.filepath, selectedAttIndex: i })}
                                            > Attachment {i + 1}</button>

                                        )
                                    })}

                                </div>
                                <div className="col-md-10">
                                    <div className="text-center">
                                        <iframe src={this.state.selectedImag} height="500" width="450" />
                                    </div>
                                </div>
                            </div>



                        </div>

                        <div className="modal-footer addCommittee-footer">

                            <button className="btn outline-button waves-effect subunit-cancel" onClick={() => this.setState({ showAttachmentodal: false, attachmentData: [], selectedImag: '', selectedAttIndex: 0, })}>Close</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    handleDeleteModal = () => {

        const deleteGrantAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['invoice'].find(access => access === 'delete');

        if (deleteGrantAccess !== undefined) {
            if (this.state.selectedExpenseIds.length > 0) {
                this.setState({ deleteExpenseModal: true })
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'warning',
                    successMessage: 'Kindly select at least one invoice.',
                });
            }
        }
        else {
            this.setState({
                successModal: true,
                successModalType: 'warning',
                successMessage: 'This operation is restricted by the Library admin.'
            });
        }
    }

    // METHOD TO EXPORT EXPENSES DETAILS
    exportExpenseDetails = () => {
        this.setState({
            exportDetails: true
        }, () => {
            document.getElementById('expenseExport').click();

            this.setState({
                exportDetails: false
            });
        });
    }

    // EXPORT TABLE TO CSV
    tableToCSV = () => {
        // Creating csv string with headers
        let csvString = `\n"Purchase Order Name","Bill Date*","Bill Number*","Amount*","Note"\n`;

        // Adding sample hard-coded data
        const sampleData = [
            ["Sample New PO", "	2024-12-06", "NEWPO100", "1500", "Sample Note Data"],
        ];

        // Adding each row of sample data to csvString
        sampleData.forEach(row => {
            csvString += `"${row.join('","')}"\n`;
        });

        if (csvString !== '') {
            var downloadLink = document.createElement('a');
            downloadLink.download = "sample-invoice-details.csv";
            downloadLink.href = 'data:application/csv;charset=UTF-8,%EF%BB%BF' + encodeURIComponent(csvString);
            downloadLink.target = '_blank';
            document.getElementById('exportList').appendChild(downloadLink);
            downloadLink.click();
        }
    }

    render() {
        return (
            <>
                <RoutingMenu activeScreen="invoice" />
                <div className="libraryComponents-container">
                    <div>
                        <div className="pt-1">
                            <h4>Invoice</h4>
                        </div>
                        <div className="pageMainSectionContainer">
                            <div className="expenseHeaderContainer">
                                <div className="expenseActionContainer">
                                    <CSVLink
                                        style={{ display: "none" }}
                                        className="exportCSVExpenseData"
                                        data={this.state.exportCSVData}
                                        headers={this.state.exportCSVHeaders}
                                        filename={"ExpenseList.csv"}
                                    >
                                        Download
                                    </CSVLink>
                                    <div class="dropdown">
                                        <button class="btn btn-primary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown">Action</button>
                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                            {/* <span
                                                title="Click to export selected expenses"
                                                class="dropdown-item"
                                                onClick={() => this.checkSelectedTableRowsForExport()}
                                                style={{ cursor: "pointer" }}
                                            >Export</span> */}
                                            <span
                                                title="Click to delete selected expenses / bills"
                                                class="dropdown-item"
                                                style={{ cursor: "pointer" }}
                                                onClick={() => this.handleDeleteModal()}
                                            // onClick={() => this.setState({ deleteExpenseModal: true })}
                                            >Delete</span>
                                        </div>
                                    </div>
                                    <div id="perPageSelectContainer">
                                        <p>Show</p>
                                        <select onChange={(e) => this.setState({ limit: e.target.value, offset: 0, activePage: 1 }, () => { this.getExpenses() })}>
                                            <option value={10} selected={this.state.limit == 10}>10</option>
                                            <option value={20} selected={this.state.limit == 20}>20</option>
                                            <option value={30} selected={this.state.limit == 30}>30</option>
                                            <option value={40} selected={this.state.limit == 40}>40</option>
                                            <option value={50} selected={this.state.limit == 50}>50</option>
                                        </select>
                                        <p>entries</p>
                                    </div>
                                </div>
                                <div id="routingMenuContainer">
                                    <div style={{ display: 'none' }}>
                                        <ReactHTMLTableToExcel
                                            id="expenseExport"
                                            className="btn outline-button waves-effect text-capitalize"
                                            table='expenseTable'
                                            filename="Invoice List"
                                            sheet="tablexls"
                                            buttonText="Export to Excel"
                                        />
                                    </div>
                                    <div className="dropdown" id="expenseDropdownButton">
                                        <button className="btn btn-outline-primary" title="Click here to export" type="button" id="expensesButton" onClick={() => this.exportExpenseDetails()}>
                                            <FontAwesomeIcon icon={['fas', 'file-export']} size="md" style={{ marginRight: 10 }} />Export
                                        </button>
                                    </div>

                                    <div className="dropdown" id="expenseDropdownButton">
                                        <ImportInvoice
                                            export={this.tableToCSV}
                                        />
                                    </div>

                                    <div className="dropdown" id="expenseDropdownButton">
                                        <button className="btn btn-outline-primary" title="Click here to add" type="button" id="expensesButton" onClick={() => this.addBillAccess()}>
                                            <FontAwesomeIcon icon={['fas', 'plus']} size="md" style={{ marginRight: 10 }} />Add
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="expenseList">
                                <table className="table jumbotron" id='expenseTable'>
                                    <thead>
                                        <tr>

                                            {
                                                !this.state.exportDetails &&
                                                <th>
                                                    <input
                                                        type="checkbox"
                                                        name="selectAll-expenses"
                                                        checked={this.state.allSelected}
                                                        onClick={(e) => this.selectAllExpenses(e)}
                                                    />
                                                </th>
                                            }
                                            <th>Sr. No.</th>
                                            {/* <th>Payment Date</th> */}
                                            <th>Payee Name</th>
                                            {/* <th>Type</th> */}
                                            <th>Amount (In Rs.)</th>
                                            {/* <th>Linked To</th> */}
                                            <th>Bill Number</th>
                                            <th>Bill Date</th>
                                            {/* <th>Due Date</th> */}
                                            <th>Attachment</th>
                                            {
                                                !this.state.exportDetails &&
                                                <th>Action</th>
                                            }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.isExpenseFetching ?
                                                <tr>
                                                    <td colSpan={12}>
                                                        <ButtonLoader />
                                                    </td>
                                                </tr>
                                                :
                                                Object.values(this.state.expenseList).length > 0 ?
                                                    Object.values(this.state.expenseList).reverse().map((expense, index) => {

                                                        return (
                                                            <tr key={expense.Uniqueid}>
                                                                {
                                                                    !this.state.exportDetails &&
                                                                    <td style={{ padding: '0.5rem' }} >
                                                                        <input
                                                                            type="checkbox"
                                                                            name="selectOne-expense"
                                                                            checked={this.state.selectedExpenseIds.includes(expense.Uniqueid)}
                                                                            onClick={() => this.selectSingleExpense(expense.Uniqueid)}
                                                                        />
                                                                    </td>
                                                                }
                                                                <td style={{ padding: '0.5rem' }} >{this.state.offset + index + 1}.</td>
                                                                {/* <td style={{ padding: '0.5rem'}} >{expense.paymentDate == '0000-00-00' ? "" : expense.paymentDate}</td> */}
                                                                <td style={{ padding: '0.5rem' }} >{expense.vendorName}</td>
                                                                {/* <td>{expense.expenseType}</td> */}
                                                                <td style={{ padding: '0.5rem' }} >Rs. {expense.totalAmount} /-</td>
                                                                {/* <td>{expense.linkTo}</td> */}
                                                                <td style={{ padding: '0.5rem' }} >{expense.billNumber}</td>
                                                                <td style={{ padding: '0.5rem' }} >{expense.billDate == '0000-00-00' ? "" : expense.billDate}</td>
                                                                {/* <td style={{ padding: '0.5rem'}} >{expense.dueDate == '0000-00-00' ? "" : expense.dueDate}</td> */}
                                                                {
                                                                    expense.attachment.length == 0 ?
                                                                        <td style={{ padding: '0.5rem' }} title=" Attachment not added yet" >{expense.attachment.length}</td>
                                                                        :
                                                                        <td
                                                                            style={{ cursor: 'pointer', color: '#0465ac', padding: '0.5rem' }}
                                                                            onClick={(e) => this.setState({ showAttachmentodal: true, attachmentData: expense.attachment })}
                                                                            title="Click to view attachment"
                                                                        >
                                                                            {expense.attachment.length}
                                                                        </td>
                                                                }
                                                                {
                                                                    !this.state.exportDetails &&
                                                                    <td style={{ padding: '0.5rem' }} >
                                                                        <FontAwesomeIcon icon={['far', 'eye']} size="lg" title="Click to view invoice details" style={{ cursor: "pointer", marginRight: 5 }} onClick={() => this.viewExpenseDetails(expense)} />
                                                                        <FontAwesomeIcon icon={['far', 'edit']} size="lg" title="Click to edit invoice details" style={{ cursor: "pointer", marginRight: 5 }} onClick={() => this.editExpense(expense)} />
                                                                        <FontAwesomeIcon icon={['far', 'trash-alt']} size="lg" title="Click to delete invoice" style={{ cursor: "pointer", marginRight: 5 }} onClick={() => this.deleteSingleExpense(expense)} />
                                                                    </td>
                                                                }
                                                            </tr>
                                                        )
                                                    })
                                                    :
                                                    <tr>
                                                        <td colSpan="12">No expense added yet. Please click 'Add' to add the expense.</td>
                                                    </tr>
                                        }
                                    </tbody>
                                </table>
                                {
                                    Object.values(this.state.expenseList).length > 0 &&
                                    <div id="settingPaginationContainer">
                                        <Pagination
                                            activePage={this.state.activePage}
                                            itemsCountPerPage={this.state.limit}
                                            totalItemsCount={this.state.totalCount}
                                            pageRangeDisplayed={3}
                                            onChange={(num) => this.updatePaginationCount(num)}
                                        />
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                {
                    this.state.successModal &&
                    <SuccessModal
                        successModal={this.state.successModal}
                        successModalType={this.state.successModalType}
                        successMessage={this.state.successMessage}
                        closeSuccessModal={this.closeSuccessModal}
                    />
                }
                {
                    this.state.addBillModal &&
                    <AddBill
                        addBillModal={this.state.addBillModal}
                        closeAddBillModal={this.closeAddBillModal}
                        isEditMode={this.state.isEditMode}
                        uniqueId={this.state.uniqueId}
                        vendorId={this.state.vendorId}
                        vendorName={this.state.vendorName}
                        poId={this.state.poId}
                        poName={this.state.poName}
                        poAmount={this.state.poAmount}
                        dueDate={this.state.dueDate}
                        billDate={this.state.billDate}
                        billNumber={this.state.billNumber}
                        linkTo={this.state.linkTo}
                        taxType={this.state.taxType}
                        note={this.state.note}
                        attachments={this.state.attachments}
                        attachmentCount={this.state.attachmentCount}
                        totalAmount={this.state.total_amount}
                        assetCategoryDetails={this.state.assetCategoryDetails}
                        attachmentJson={this.state.attachmentArray}
                        getExpenses={this.getExpenses}
                        getMessage={this.getMessage}
                    />
                }
                {
                    this.returnDeleteExpenseModal()
                }
                {
                    this.returnViewExpenseModal()
                }
                {
                    this.showAttachmentodalModal()
                }
            </>
        )
    }
}

const mapStateToProps = store => {
    return {
        // VARIABLES TO GET AGENCY DETAILS
        accessibleOperations: store.RouteMenuReducer.accessibleOperations,
        isAdmin: store.RouteMenuReducer.isLibraryAdmin
    };
};

export default connect(mapStateToProps)(Invoice);